module.exports = __webpack_public_path__ + "img/bg-video-5.a3f5c2e9.png";